import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { profileHexagon } from "../../../assets/constant";
import OverviewItem from "../../../components/OverviewItem";
import useApi from "../../../Hooks/useApi";
import useLoader from "../../../Hooks/useLoader";
import {
  reSetNotifications,
  setTotalCount,
} from "../../../store/notificationSlice";
import styles from "./RightAside.module.css";
import useScreenSize from "../../../Hooks/useScreenSize";
const RightAside = ({ sidebarRightAside, isSidebarClose, classes }) => {
  const { communityId, roleName } = useSelector((state) => state?.authReducer);

  const dispatch = useDispatch();
  const { loading, setLoading } = useLoader();
  const { GetNotificationsList } = useApi();
  const notifications = useSelector(
    (state) => state?.notificationReducer?.notifications
  );
  const { user, } = useSelector((state) => state?.authReducer);
  const location = useLocation();
  const navigate = useNavigate();

  const screen = useScreenSize();
  const notificationsData = [
    // {
    //   name: "Amaan Ali",
    //   description: "maintenance collected from A-308",
    //   time: "2 min",
    // },
    // {
    //   name: "Paras",
    //   description: "approval request",
    //   time: "2 hour",
    // },
    // {
    //   name: "Umair",
    //   description: "waved amount for A-404",
    //   time: "3 min ago",
    // },
  ];



  console.log("Screen =>", screen);

  const getNotificationsListHandler = async () => {
    setLoading(true);
    await GetNotificationsList({
      pageNumber: 1,
      pageSize: 10,
      search: "",
      communityId,
    })
      .then((response) => {
        if (response?.data?.headers?.code === 200) {

          dispatch(reSetNotifications(response?.data?.body?.items));
          dispatch(setTotalCount(response?.data?.body?.totalItems));
          setLoading(false);
          return response?.data?.body?.items;
        } else {
          toast.error(response?.data?.headers?.msg);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if(screen?.width>1024){
    if (roleName?.toLowerCase() !== "QP_CB_User"?.toLowerCase()) {
      getNotificationsListHandler();
    } else {
      dispatch(reSetNotifications([]))
    }
  }
  }, [location?.pathname, roleName]);

  const tagName =
    user?.userName?.split(" ")?.length > 1
      ? user?.userName?.split(" ")[0]?.charAt(0) +
      user?.userName?.split(" ")[1]?.charAt(0)
      : user?.userName?.slice(0, 2);

  return (
    <aside
      className={[
        classes["sidebar-side-transition"],
        classes["sidebar__sideContent"],
        isSidebarClose && classes["width-0"],
        styles["customStyles"],
      ].join(" ")}
      ref={sidebarRightAside}
    >
      <div className={styles["profileWrappper"]}>
        <span>{tagName}</span>
        <img src={profileHexagon} />
        <div className={styles["userDetails"]}>
          <h1>{user?.userName}</h1>
          <h4>{user?.emailAddress}</h4>
        </div>
      </div>
      <div className={styles["notificationSection"]}>
        <div className={styles["heading"]}>
          <h2>Notifications</h2>
          {roleName?.toLowerCase() !== "QP_CB_User"?.toLowerCase() && (
            <p onClick={() => navigate("/notifications")}>See all</p>
          )}
        </div>
        <div className={styles["mainWrapper"]}>
          {notifications?.length ? (
            notifications?.map((item, index) => {

              return (
                <OverviewItem key={index} name={user?.userName} data={item} />
              );
            })
          ) : (
            <div className={styles["heading"]}>
              <p className={styles["no-noti"]}>No Notifications</p>
            </div>
          )}
        </div>
      </div>
      {/* <div className={styles["memberSection"]}>
        <div className={styles["heading"]}>
          <h2>New Members</h2>
          <p>See all</p>
        </div>
        <div className={styles["mainWrapper"]}>
          {membersData?.length ? membersData?.map((item, index) => (
            <OverviewItem
              key={index}
              name={item.name}
              description={item.description}
              time={item.time}
            />
          ))
            :
           <div className={styles["heading"]}>
              <p>No Members</p>
            </div>
          }
        </div>
      </div> */}
    </aside>
  );
};

export default RightAside;
